<script>
import vSelect from "vue-select"
import "vue-select/dist/vue-select.css"
import _ from "underscore"
//import TextField from "@/components/global/TextField"

export default {
  components: {
    vSelect,
    //TextField,
  },
  props: {
    value:      { type: Object, required: true  },
    forceLabel: { type: Boolean, default: false },
  },
  data() {
    return {
      debug: false,
      options: [],
      selected: null,
      selectedCollection: null,
      key: 0,
      observer: null,
      limit: 10,
      search: "",
    }
  },
  computed: {
    filtered () {
      return this.options.filter(itm => itm.text ? itm.text.toLowerCase().includes(this.search.toLowerCase()) : false)
    },
    paginated () {
      return this.filtered.slice(0, this.limit)
    },
    hasNextPage () {
      return this.paginated.length < this.filtered.length
    },
    clearable () {
      return this.value.clearable !== null ? this.value.clearable : true
    },
    readOnly () {
      return this.value.readOnly !== null ? this.value.readOnly : false
    },
    defaultLabel () {
      return this.value.defaultLabel !== null ? this.value.defaultLabel : ""
    },
  },
  watch: {
    value: {
      handler(data) {
        if (this.debug) console.log("[CollectionTypePicker.vue] (watch)value:", data) 
        this.$emit("input", data)
        if (!data) {
          this.retrieveStatusCodes()
        } else {
          this.updateSelected(data.value)
        }
      },
      deep: true,
    },
    selected(sel) {
      this.selectedCollection = sel
      if (this.debug) console.log("[CollectionTypePicker.vue] (watch)selected:", sel)
      //this.$emit("change", sel)
      this.value.value = sel !== null ? sel.value : ""
    },
  },
  created() {
    if (this.debug) console.log("[CollectionTypePicker.vue - created] value:", this.value)
    this.retrieveStatuses()
    this.observer = new IntersectionObserver(this.infiniteScroll)
  },
  methods: {
    updateSelected(newVal) {
      if (this.debug) console.log("[CollectionTypePicker.vue] updateSelected:", newVal) 
      if (newVal === null) newVal = ""
      const sel = _.find(this.options, (val) => {
        return val.value == newVal
      })
      this.selected = typeof(sel) !== "undefined" ? sel : null
      this.$emit("change", this.selected)
    },
    retrieveStatuses() {
      if (this.debug) console.log("[CollectionTypePicker.vue] retrieveStatuses: selected", this.value)
      this.$store.dispatch("asset/getCollectionTypes").then((data) => {
        const itemList = []//[{ value: "", text: this.defaultLabel }]

        data.nodes.forEach((itm) => {
          itemList.push({
            value: itm.collectionTypeCode,
            text: itm.collectionTypeName,
          })

          if (itm.collectionTypeCode == this.value.value) {
            this.selected = {
              value: itm.collectionTypeCode,
              text: itm.collectionTypeName,
            }
          }
        })

        this.options = itemList
        this.key++
      })
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async infiniteScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.limit += 10
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
  },
}
</script>

<template>
  <div class="collectionTypePicker">
    <label
      v-if="forceLabel"
      :for="value.id"
    >
      {{ value.label }}:
    </label>
    <v-select 
      v-model="selected"
      :id="value.id"
      :key="key"
      label="text"
      :options="paginated"
      :filterable="false"
      :clearable="clearable"
      :disabled="readOnly"
      @open="onOpen"
      @close="onClose"
      @search="query => search = query"
    >
      <template #list-footer>
        <li v-show="hasNextPage" ref="load" class="loader">
          Loading more options...
        </li>
      </template>
    </v-select>
  </div>
</template>

<style>
  .assetTypePicker div.vs__dropdown-toggle {
    background: white;
  }
</style>
